import { SingleTeacherView } from "../components/singleTeacher/SingleTeacherView";

export const SingleTeacher = () => {
  return (
    <div>
      <SingleTeacherView />
    </div>
  );
};
